import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/img/plus.png";
import api from "../../services/api";

const PeerForm = ({ newPeerAdded, setNewPeerAdded }) => {
  const [formVisible, setFormVisible] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [payload, setPayload] = useState({
    username: "",
    contact_number: "",
    days: 5,
  });

  const handlePayloadUpdate = (e) => {
    let { name, value } = e.target;
    if (name == "days") {
      value = parseInt(value);
    }
    setPayload({ ...payload, [name]: value });
  };

  function validatePayload() {
    const { username, contact_number, days } = payload;

    // Validate username
    const usernameRegex = /^[a-zA-Z\s]+[a-zA-Z0-9_\s-]{2,19}$/;
    const isUsernameValid = usernameRegex.test(username);

    // Validate contact number
    const contactNumberRegex = /^\+\d{11,13}$/;
    const isContactNumberValid = contactNumberRegex.test(contact_number);

    // Validate days
    const isDaysValid = typeof days === "number" && days >= 0;

    return isUsernameValid && isContactNumberValid && isDaysValid;
  }

  const addNewPeer = async (e) => {
    try {
      e.preventDefault();
      const response = await api.post("/order/create", payload);

      if (response.status === 200) {
        setNewPeerAdded(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (validatePayload()) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [payload]);

  useEffect(() => {
    setFormVisible(false);
    setPayload({
      username: "",
      contact_number: "",
      days: 5,
    });
  }, [newPeerAdded]);

  return (
    <div className="flex flex-col mx-6 justify-center my-3">
      <div className="flex flex-col items-end w-full">
        <button
          className="border-2 rounded border-[#e5e5e5] hover:bg-[#fafafa] w-fit py-1 px-1 sm:py-1.5 sm:px-2 text-gray-600 flex justify-center items-center space-x-2 font-semibold md:text-base text-xs"
          onClick={() => setFormVisible(!formVisible)}
        >
          <span>
            <img src={PlusIcon} alt="Add" className="md:size-3 size-2" />
          </span>
          <span>New peer</span>
        </button>
      </div>

      {formVisible ? (
        <form
          className="flex flex-col sm:flex-row items-center sm:items-end justify-center sm:space-x-2 my-2 sm:w-11/12 md:w-4/5 lg:w-1/2 sm:mx-auto sm:my-4"
          onSubmit={addNewPeer}
        >
          <div className="w-full mb-1">
            <label
              htmlFor="username"
              className="block mb-1 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-600 px-1"
            >
              User Name
            </label>
            <input
              type="text"
              id="username-field"
              name="username"
              value={payload.username}
              className="bg-gray-50 border-2 border-gray-300 font-medium text-gray-600 text-xs sm:text-sm rounded-lg focus:border-gray-400 focus:ring-gray-400 focus-visible:outline-none block w-full px-2 py-1 sm:p-2"
              onChange={handlePayloadUpdate}
              required
            />
          </div>
          <div className="w-full mb-1">
            <label
              htmlFor="contact_number"
              className="block mb-1 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-600 px-1"
            >
              Contact Number
            </label>
            <input
              type="text"
              id="contact-field"
              name="contact_number"
              value={payload.contact_number}
              placeholder="+919876543210"
              className="bg-gray-50 border-2 border-gray-300 font-medium text-gray-600 text-xs sm:text-sm rounded-lg focus:border-gray-400 focus:ring-gray-400 focus-visible:outline-none block w-full px-2 py-1 sm:p-2"
              onChange={handlePayloadUpdate}
              required
            />
          </div>
          <div className="w-full mb-1">
            <label
              htmlFor="days"
              className="block mb-1 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-600 px-1"
            >
              Validity (days)
            </label>
            <input
              type="number"
              id="days-field"
              name="days"
              value={payload.days}
              className="bg-gray-50 border-2 border-gray-300 font-medium text-gray-600 text-xs sm:text-sm rounded-lg focus:border-gray-400 focus:ring-gray-400 focus-visible:outline-none block w-full px-2 py-1 sm:p-2"
              onChange={handlePayloadUpdate}
              required
            />
          </div>
          <button
            type="submit"
            className={`text-white font-semibold sm:mb-1.5 ${
              isValid
                ? "bg-red-wood-light hover:bg-red-wood focus:outline-red-wood"
                : "bg-gray-200 focus-outline-gray-200 cursor-not-allowed text-gray-600"
            } rounded-lg text-sm w-full sm:w-auto px-5 py-1.5 sm:py-2 my-0.5 text-center`}
            disabled={!isValid}
          >
            Submit
          </button>
        </form>
      ) : null}
    </div>
  );
};

export default PeerForm;
